import styled from "styled-components";

export const IntegrationsWrapper = styled.section`
   padding: 3em;
`;

export const IntegrationsSlide = styled.div`
   display: flex;
   justify-content: space-around;
   align-items: center;
   flex-wrap: nowrap;
   margin: 3em 0;
`;

export const ImageWrapper = styled.div`
   display: inline;
`;
